import { getKeys } from './getKeys'

export const gpConnectTranslations = {
  PATIENT_DETAILS: 'Patient Details',
  PATIENT_SUMMARY: 'Patient Summary',
  SUMMARY: 'Summary',
  ADDRESS: 'Address: ',
  GENDER: 'Gender: ',
  GP_DETAILS: 'GP Details: ',
  DOB: 'DOB: ',
  NHS_NO: 'NHS No.: ',
  PAS_NO: 'PAS No.: ',
  CONTACT: 'Contact: ',
  NOT_FOUND: 'Patient Record Not Found',
  OPS: 'Oops... Please contact support if this error persists',
  SITE_INFORMATION: 'Site information',
  TELEPHONE: 'Telephone',
  EDIT: 'Edit',
  CANCEL: 'Cancel',
  REGULATOR: 'Regulator',
  NO_INFORMATION_ADDED: 'No information added',
  WHERE_TO_FIND_YOUR: 'Where to find your Regulatory Identifier',
  REGULATORY_IDENTIFIER: 'Regulatory identifier',
  REGULATORY_BODY: 'Regulatory body',
  REGULATORY_person: 'Regulatory person',
  GP_CONNECT: 'GP Connect',
  INTEGRATION_SETUP: 'Integration Setup',
  ODS_CODE: 'ODS Code',
  ASID_CODE: 'ASID Code',
  START: 'Start',
  SIGN: 'Sign',
  GP_GAINING: 'GP Connect National Data Sharing Arrangement (NDSA)',
  GP_SIGN_INTRO_1: 'GP Connect National Data Sharing Arrangement (NDSA)',
  GP_SIGN_INTRO_2:
    'As a care provider you`ll be familiar with using Log my Care to help you deliver the best quality and appropriate care.',
  GP_SIGN_INTRO_3:
    'However, you can also now view key data from your service users` NHS Primary Care Patient Record to enhance your understanding of their needs.',
  GP_SIGN_INTRO_4:
    'This link provides you with HTML “view only” access to allow the allowable information. It will not allow you to comment on, supplement, download or share this data.',
  GP_SIGN_INTRO_5:
    'Using the GP Connect system does require some prior Information Governance to have been completed to demonstrate compliance with the UK GDPR. To gain access to the HTML View of GP Connect you /your care service will commit to certain conditions.  You are required to:',
  GP_SIGN_POINT_1:
    '1. Confirm that your service has completed or has a plan to complete the NHS`s Data Security and Privacy Toolkit (DSPT). This gives assurance to the sharing party - local GP surgeries - that you have data governance and data protection rules in place, and that they can “trust you” to apply the same rules in looking after patient data as they are required to follow.',
  GP_SIGN_POINT_2:
    '2. Read, understand, and accept the Acceptable Use Policies concerning data shared by the surgeries (the Connecting Party in their terminology) with you as, in their language, an End User Organisation.',
  GP_SIGN_POINT_3:
    '3. NHS England require that the use of GP connect data is overseen by a clinically trained member of staff.',
  GP_SIGN_POINT_4:
    '4. Update your privacy notice (example below) and, probably, update your privacy policy.',
  GP_SIGN_POINT_5:
    'You do not have to complete a Data Protection Impact Assessment.',
  GP_SIGN_CONTENT_1:
    'For the avoidance of doubt, in viewing data using GP Connect, you are a Data Processor, the surgeries who own the data and will provide it to you are the Data Controllers.',
  GP_SIGN_CONTENT_2:
    'In signing up to the service via Log my Care, you are asked to confirm that both conditions above are met before access is granted. Your responses are held within the system. Using Log my Care helps you to abide by the Acceptable Use Policies, and you may have already met the DSPT targets.',
  GP_SIGN_CONTENT_3:
    'You are also required to make an addition to your Privacy Notice, explaining to your service users that you will have access to additional information from an external source - in this case the local GP surgery that they are registered with. We have created this template for you and added it to the Consent Management Templates Library so it can be added via a service user`s profile.',
  GP_SIGN_CONTENT_4:
    'Log my Care has included the Acceptable Use Policy as part of this pack (so that you may read it before agreeing to it), and an example the necessary changes to your Privacy Notice.',
  GP_SIGN_CONTENT_5:
    'By signing this agreement, you will be granted a clinical access role in Log my Care',
  DPO: 'Name of Registered Manager / DPO / Director: ',
  AGREED_DATE: 'Agreed date',
  AGREEMENT_SIGNED: 'AGREEMENT SIGNED',
  VIEW_DATA_SHARING: 'View National Data Sharing Agreement',
  NEXT_STEP: 'Next steps for setting up GP Connect',
  BE_AWARE: 'Please be aware that GP connect currently only covers England.',
  I_HAVE: 'I have read and understood the agreement',
  CANNOT: 'Can not find your ODS Code. Please ensure your DSPT is up to date',
  T0_GET_STARTED:
    'To get started with GP Connect, you need to enter your Regulatory Identifier.',
  WARNING:
    '▲ WARNING: You should only commit if you are known to be DSPT Standards Met. You will be in breach of the obligations set out if you sign and are not DSPT Standards Met.',
  UNREGULATED: 'Unregulated',
  GP_POLICY_SEC_1: 'Acceptable Use Policy',
  GP_POLICY_SEC_2: 'End User Organisation Acceptable Use Policy (AUP)',
  THE_PRIVACY:
    'The Privacy Notice for GP Connect must be signed before viewing this record',
  YOU_CAN_FIND_MORE_CONSENT: 'You can find the consent form',
  SET_UP_COMPLETED: 'SET UP COMPLETED',
  NON_CLINICAL: '(Non-clinical)',
  YOU_MUST:
    'You must complete GP Connect onboarding before viewing this record',
  THIS_PATIENT_1:
    'This patient does not have a valid NHS number which is required to view the record.',
  THIS_PATIENT_2: 'Add it to their',
  THIS_PATIENT_3: 'profile',
  THIS_PATIENT_4: 'under ‘Care related information’.',
  ERROR_DECEASED_PATIENT:
    'This record belongs to a deceased patient and cannot be accessed.',
  ERROR_SENSITIVE_PATIENT:
    'This record has been highlighted as sensitive and therefore cannot be shown.',
  UNEXPECTED_ERROR: 'An unexpected error occurred. Please try again.',
  SUPERSEDED_WARNING:
    'The NHS Number provided ({{nhsNumber}}) has been superseded ',
  PLEASE_UPDATE: 'Please update ',
  HERE: 'here',
  FAMILY_NAME_MISMATCH: 'Family Name does not match: {{familyName}}',
  GIVEN_NAME_MISMATCH: 'Given Name does not match: {{givenName}}',
  UPDATE_RECORDS: 'Please update your records ',
  GENDER_MISMATCH: 'Gender does not match: {{gender}}',
  DOB_MISMATCH: 'Birth Date does not match: {{dob}}',
  INTEGRATION_SETUP_URL:
    'https://support.logmycare.co.uk/en/articles/10470275-how-to-set-up-gp-connect-integration',
}

export const gpConnectConstants = getKeys(gpConnectTranslations)
